import { useZAFClient } from '@/features/zendesk-app'
import { Links } from '@/config/app'

export const useOpenWebhook = (id: string | undefined) => {
  const zafClient = useZAFClient()!
  return async () => {
    if (!id) return
    const context = await zafClient.context()
    const subdomain = context.account.subdomain
    window.open(`https://${subdomain}.zendesk.com/admin/apps-integrations/webhooks/webhooks/${id}/details`, '_blank')
  }
}

export const useOpenAuthenticationArticle = () => {
  return () => window.open(Links.authenticationArticle, '_blank')
}
